import React, { useEffect, useState } from "react";
import ApproveBidsModal from "./approveBidsModal";
import { Link } from "react-router-dom";
import CustomConfirmBox from "./customConfirmBox";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import biddingGeneratorService from "../../components/Services/biddingGenerator.service";
import biddingConsumerService from "../../components/Services/biddingConsumer.service";
import ReceivedBankingRequests from "../Auth/Banking/receivedBankingRequests";
import bankingService from "../../components/Services/banking.service";
import NodataFound from "../../commons/Toast/noDataFound";
import { CircularProgress } from "@mui/material";
import {
  getSpeceficTraders,
  getSpeceficTradersNew,
} from "../../store/Analyst/action";

const BidsReceive = () => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state?.sessionState?.role);
  const configKey = useSelector((state) => state?.sessionState?.connectionName);
  const currentRoute = window.location.pathname;

  const selectedCapacityData = useSelector(
    (state) => state?.dashboardReducer?.selectedCapacityData || []
  );
  const [isApproveBidsModal, setApproveBidsModal] = useState(false);
  const [reviseOpen, setReviseOpen] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [receivedBidsList, setReceivedBidsList] = useState(null);
  const [comparedBids, setComparedBids] = useState(null);
  console.debug(receivedBidsList);
  const [loader, setLoader] = useState(false);
  const [selTrader, setSelTrader] = useState("");

  const [pushTCmodal, setpushTCmodal] = useState(false);
  const [pushTcData, setPushTcData] = useState({});
  const [connectLoadingId, setConnectLoadingId] = useState(null);

  const traderList = useSelector(
    (state) => state?.analystReducer?.companyTraders
  );

  useEffect(() => {
    let selectedTrader = traderList?.filter(
      (ele) => ele?.id === selectedCapacityData?.traderAssigned
    )?.[0];
    setSelTrader(selectedTrader?.userName);
  }, [traderList]);

  useEffect(() => {
    if (selectedCapacityData) {
      getSpeceficTradersNew(selectedCapacityData?.company?.companyId)(dispatch);
    }
  }, [selectedCapacityData]);

  useEffect(() => {
    if (!isApproveBidsModal) {
      let elem = document.getElementsByTagName("body");
      elem.length > 0 && (elem[0].style.overflow = "");
    }
  }, [isApproveBidsModal]);
  const handleRevise = () => {
    setReviseOpen(true);
  };

  const handleReviseClose = () => {
    setReviseOpen(false);
    toast.success("Notification sent", toastProperties);
  };
  const handleReviseCloseNo = () => {
    setReviseOpen(false);
  };

  const getComparedBidDetails = (bidId) => {
    if (role === "GENERATOR") {
      biddingGeneratorService
        .getReceivedBidsListByGenCapacityId(selectedCapacityData?.id, bidId)
        .then((response) => {
          if (response?.data?.code === 200) {
            setComparedBids(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
    } else if (role === "CONSUMER") {
      biddingConsumerService
        .getReceivedBidsListByConCapacityId(selectedCapacityData?.id, bidId)
        .then((response) => {
          if (response?.data?.code === 200) {
            setComparedBids(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
    }
  };
  const handleApproveBids = (item) => {
    setApproveBidsModal(true);
    setJsonData(item);
    getComparedBidDetails(item?.id);
  };

  const closeApproveBidsModal = () => {
    setApproveBidsModal(false);
  };

  const getReceivedBidsGenerator = () => {
    setReceivedBidsList(null);
    biddingGeneratorService
      .getReceivedBidsGenerator(selectedCapacityData?.id, false)
      .then((response) => {
        if (response?.data?.code === 200) {
          setReceivedBidsList(response?.data?.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      });
  };

  const getReceivedBidsConsumer = () => {
    setReceivedBidsList(null);
    biddingConsumerService
      .getReceivedBidsConsumer(selectedCapacityData?.id, false)
      .then((response) => {
        if (response?.data?.code === 200) {
          setReceivedBidsList(response?.data?.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      });
  };

  const getReceivedConnectionsBanknig = () => {
    setReceivedBidsList(null);
    bankingService
      .getReceivedBankingRequests(selectedCapacityData?.id)
      .then((response) => {
        if (response?.data?.code === 200) {
          setReceivedBidsList(response?.data?.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };
  useEffect(() => {
    setLoader(true);
    role === "BANKING"
      ? getReceivedConnectionsBanknig()
      : role === "CONSUMER"
      ? getReceivedBidsConsumer()
      : getReceivedBidsGenerator();
  }, []);

  const [isReceivedBankModal, setIsReceivedBankModal] = useState(false);
  const openReceivedBankModal = (item) => {
    setIsReceivedBankModal(item);
  };
  const closeReceivedBankModal = () => {
    setIsReceivedBankModal(false);
  };

  const handlePushToTradeConnectPlatform = async () => {
    const reqBoby = {
      childCapacityId: pushTcData?.id,
      type: "RECEIVED",
    };

    try {
      let response;
      if (role === "CONSUMER") {
        response = await biddingConsumerService.pushToTradeConnectFromConRole(
          reqBoby
        );
      } else if (role === "GENERATOR") {
        response = await biddingGeneratorService.pushToTradeConnectFromGenRole(
          reqBoby
        );
      }

      if (response?.data?.code === 200) {
        toast.success(response?.data?.message, toastProperties);
        return true;
      } else {
        toast.error("Something went wrong", toastProperties);
        return false;
      }
    } catch (err) {
      console.log("API call error", err);
      toast.error("API failed", toastProperties);
      return false;
    }
  };

  const handleOpenPushTc = (data) => {
    setConnectLoadingId(data.id);
    setPushTcData(data);
    setpushTCmodal(true);
  };

  const handleClosePushTc = (data) => {
    if (role === "GENERATOR" && pushTcData?.id) {
      biddingGeneratorService
        .bidRequestRejectConsumer(pushTcData?.id)
        .then((response) => {
          if (response?.data?.code === 200) {
            toast.success(response?.data?.message, toastProperties);
            window.location.reload();
          } else {
            toast.error(response?.data?.message, toastProperties);
          }
        })
        .catch((err) => console.log("Api Call Err:", err));
    } else if (role === "CONSUMER" && pushTcData?.id) {
      biddingGeneratorService
        .bidRequestRejectGenerator(pushTcData?.id)
        .then((response) => {
          if (response?.data?.code === 200) {
            toast.success(response?.data?.message, toastProperties);
            window.location.reload();
          } else {
            toast.error(response?.data?.message, toastProperties);
          }
        })
        .catch((err) => console.log("Api Call Err:", err));
    }
    handleClose();
  };

  const handleClose = () => {
    setpushTCmodal(false);
    setConnectLoadingId(null);
  };

  const handleClosePopup = () => {
    setpushTCmodal(false);
    setConnectLoadingId(null);
  };

  return (
    <>
      {pushTCmodal && (
        <CustomConfirmBox
          title={"Bilateral Connect"}
          message={"Do you want to proceed with bilateral connect?"}
          handleClose={handleClosePushTc}
          handleClosePopup={handleClosePopup}
          handleSuccess={handlePushToTradeConnectPlatform}
          open={pushTCmodal}
          loading={connectLoadingId !== null}
        />
      )}
      {isReceivedBankModal && (
        <ReceivedBankingRequests
          isOpen={isReceivedBankModal}
          closeReceivedBankModal={closeReceivedBankModal}
          getReceivedConnectionsBanknig={getReceivedConnectionsBanknig}
        />
      )}
      {isApproveBidsModal && (
        <ApproveBidsModal
          isOpen={isApproveBidsModal}
          comparedBids={comparedBids}
          jsonData={jsonData}
          closeApproveBidsModal={closeApproveBidsModal}
          getReceivedBidsConsumer={getReceivedBidsConsumer}
          getReceivedBidsGenerator={getReceivedBidsGenerator}
        />
      )}
      <div className="container my-5">
        <Link
          to={
            currentRoute === "/bankingRequests_received"
              ? "/banking"
              : role === "CONSUMER"
              ? "/consumer_dashboard"
              : "/dashboard"
          }
        >
          <button className="btn btn-secondary mb-3">
            <i className="fa fa-chevron-left"></i> Back to My{" "}
            {role === "BANKING" ? "Banking" : "Listing"}
          </button>
        </Link>
        <div className="landingcost-card py-4">
          <h4>Connection Requests Received</h4>
          <div className="table-responsive doc-cus-table">
            {role === "BANKING" ? (
              <>
                <h4>{selectedCapacityData?.name}</h4>
                {receivedBidsList && receivedBidsList?.length > 0 ? (
                  <table className="cus-table table-bordered my-documents-table">
                    <thead className="table-header">
                      <tr>
                        <th>S. No.</th>
                        <th>Company Name</th>
                        <th>Quantity (MW)</th>
                        <th>Banking Factor(%)</th>
                        <th>Settlement Rate (₹/KWH)</th>
                        <th>Status</th>
                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receivedBidsList.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td
                            className={
                              item?.status !== "ACCEPTED" && "company-name-blur"
                            }
                          >
                            {item?.againstBankingListing?.company?.companyName}
                          </td>
                          <td>{item?.againstBankingListing?.requiredQty}</td>
                          <td>{item?.againstBankingListing?.bankingFactor}</td>
                          <td>{item?.againstBankingListing?.settlementRate}</td>
                          <td>
                            {item?.status &&
                              (item?.status === "PLACED"
                                ? "Received"
                                : item?.status.charAt(0).toUpperCase() +
                                  item?.status.slice(1).toLowerCase())}
                          </td>
                          <td>
                            <div className="align-files-icons-btn">
                              <button
                                className="btn outline-0"
                                onClick={() => openReceivedBankModal(item)}
                              >
                                <img src="images/view-icon.png" alt="View" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : loader ? (
                  <div className="popup-background">
                    <CircularProgress />
                  </div>
                ) : (
                  <NodataFound />
                )}
              </>
            ) : (
              <>
                <h4>{selectedCapacityData?.name}</h4>

                {receivedBidsList && receivedBidsList?.length > 0 ? (
                  <table className="cus-table table-bordered my-documents-table">
                    <thead className="table-header">
                      <tr>
                        <th>S. No.</th>
                        <th>Company Name</th>
                        <th>
                          Energy Rate (₹ per Unit)
                          {/* <br /><small style={{ fontSize: '12px' }}>{role === 'CONSUMER' ? '(Generator Cost Ex-bus)' : '(Consumer Landed Cost)'}</small> */}
                        </th>
                        {/* <th>{role === 'CONSUMER' ? 'Consumer Landed Cost (₹ per Unit)' : 'Generator Cost Ex-bus (₹ per Unit)'}<br /><small style={{ fontSize: '12px' }}>(Calculated)</small></th> */}
                        <th>Quantity (MW)</th>
                        <th>Status</th>
                        <th>Connect</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receivedBidsList?.map((item, index) => (
                        <tr key={item?.id}>
                          <td>{index + 1}</td>
                          {console.debug(item)}
                          <td
                            className={
                              (role === "GENERATOR" &&
                                item?.generatorStatus !== "ACCEPTED" &&
                                "company-name-blur") ||
                              (role === "CONSUMER" &&
                                item?.consumerStatus !== "ACCEPTED" &&
                                "company-name-blur")
                            }
                          >
                            {<span>{item?.companyName}</span>}
                          </td>

                          <td>
                            {item?.amount === 0.0 && item?.energyRateStr !== ""
                              ? item.energyRateStr
                              : item?.amount?.toFixed(2)}
                          </td>

                          {/* <td>{role === 'CONSUMER' ?item?.calculatedLandedCost?.toFixed(2):item?.calculatedGeneratorCost?.toFixed(2)}</td> */}
                          <td>{item?.quantity}</td>
                          <td>
                            {console.log("status ", item?.status)}
                            {role === "GENERATOR"
                              ? item?.generatorStatus
                                ? item?.generatorStatus === "REJECTED"
                                  ? "DECLINED"
                                  : item?.generatorStatus
                                : "NA"
                              : item?.consumerStatus
                              ? item?.consumerStatus === "REJECTED"
                                ? "DECLINED"
                                : item?.consumerStatus
                              : "NA"}
                          </td>
                          <td
                            style={{
                              textTransform: "capitalize",
                              cursor: "pointer",
                              fontSize: "14px",

                              padding: "5px",
                            }}
                          >
                            {item?.pushed ? (
                              <div>Connected</div>
                            ) : item?.pushRejected ||
                              item?.consumerStatus === "REJECTED" ||
                              item?.generatorStatus === "REJECTED" ||
                              item?.consumerStatus === "WITHDRAWN" ||
                              item?.generatorStatus === "WITHDRAWN" ? (
                              <div>Rejected</div>
                            ) : item?.tcRequest && !item?.otcRequest ? (
                              <span
                                onClick={() => handleOpenPushTc(item)}
                                style={{
                                  color: "#fff",
                                  background: "#ff7d00",
                                  padding: "8px 16px",
                                  borderRadius: "8px",
                                }}
                              >
                                {"Connect" || selTrader}
                              </span>
                            ) : (
                              <span
                                style={{
                                  color: "#fff",
                                  background: "#ff7d00",
                                  padding: "8px 16px",
                                  borderRadius: "8px",
                                }}
                                onClick={() => handleApproveBids(item)}
                              >
                                Direct
                              </span>
                            )}

                            {/* {!item?.tcRequest && item?.otcRequest ? (
                              <div className="align-files-icons-btn">
                                <button
                                  className="btn outline-0"
                                  onClick={() => handleApproveBids(item)}
                                >
                                  <img src="images/view-icon.png" alt="View" />
                                </button>
                                {item.textState}
                              </div>
                            ) : (
                              "NA"
                            )}
                          </td>
                          {process.env.REACT_APP_ENV !== "prod" && (
                            <td>
                              { ? (
                                <div
                                  className="flex-row pointer-event"
                                  onClick={() =>
                                    handlePushToTradeConnectPlatform(item)
                                  }
                                >
                                  <img
                                    src="images/tradeConnect.svg"
                                    alt="View"
                                    width={"60px"}
                                  />
                                </div>
                              ) : (
                                "NA"
                              )}
                              )} */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : loader ? (
                  <div className="popup-background">
                    <CircularProgress />
                  </div>
                ) : (
                  <NodataFound />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BidsReceive;
